import "./teacher_card.scss"
